module.exports = __webpack_public_path__ + "img/عمودیی.92c9d612.png";